<app-component-html-template [(relevantAnalysisTypes)]="relevantAnalysisTypes"
  [packagingComponent]="closure" [form]="form" [componentSubtypes]="componentSubtypes"
  [callerId]="callerId" [isPreview]="isPreview" [isTracked]="isTracked" [isFormLocked]="isFormLocked"
  [historyVersions]="historyVersions" [spinnerActive]="spinnerActive" [canEditForm]="canEditForm"
  [isUserValidator]="isUserValidator" [isEditPermitted]="isEditPermitted" [imageSource]="imageSource"
  [componentTypeSelectionLabel]="'component.fields.ofClosure' | transloco" [changedMaterialsInfo]="changedMaterialsInfo"
  [isDataExchangeSubRequest]="isDataExchangeSubRequest"
  [isInOngoingDataExchange]="isInOngoingDataExchange"
  [subRequestInfo]="subRequestInfo"
  (commentAdded)="onSubRequestCommentAdded($event)"
  (submitted)="onComponentSubmit($event)" (finishSubRequestClicked)="onFinishSubRequest($event)"
  (approveSubRequestClicked)="onApproveSubRequest()"
  (historicVersionClicked)="loadHistoryVersions(closure.id)" (historicVersionChanged)="onHistoryVersionChange($event)" (versionRenamed)="changeClosureVersionName($event)"
  (materialChangeHandled)="handleMaterialChange($event)">

  <h1 header>{{ 'component.closure' | transloco }}</h1>

  <div image>
    <app-image-upload [canEditForm]="canEditForm" [images]="closure.images" (filesEdited)="onFilesEdited()">
    </app-image-upload>
  </div>

  <div certificate>
    <app-certificate-upload [canEditForm]="canEditForm" [certificates]="closure.certificates" [certificateTypes]="allCertificateTypes" (filesEdited)="onFilesEdited()">
    </app-certificate-upload>
  </div>

  <div pdf>
    <app-pdf-upload [canEditForm]="canEditForm" [pdfs]="closure.documents" (filesEdited)="onFilesEdited()">
    </app-pdf-upload>
  </div>

</app-component-html-template>
